import "./enturf_wrk.css";
import Card from "../card_section/card";
import Book from "../../../assets/Book.svg";
import React from "react";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";

function Enturf_wrk() {
  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    dots: true,
  };
  const Mobile = useMediaQuery({ maxWidth: 760 })
  
  const Tab = useMediaQuery({ minWidth: 760 });



  return (
    <>
      <div className="container-fluid mt-5">
        {Tab && (
          <div className="cnt_4 mt-5">
            <div className="row">
              <div className="col-12 text-center mt-3">
                <h1 className="cnt4_tit">
                  HOW <span className="en">EN</span>TURF WORKS
                </h1>
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-xl-12 aa mt-5 pt-5">
                <div className="container">
                  <Slider {...settings}>
                    <div>
                      <Card
                        title="Reserve"
                        description="Download the Entruf App ,select from a Wider range of handpicked turfs. Pick a timeslot and book it."
                        class="card_img img-fluid"
                        img={Book}
                      />
                    </div>
                    <div>
                      <Card
                        title="Record"
                        description="After Booking the turf,Our AI enabled cameras record the match while you enjoy playing in the turf at no extra cost. "
                        class="card_img img-fluid"
                        img={Book}
                      />
                    </div>
                    <div>
                      <Card
                        title="Relive"
                        description="Recorded videos are avaible in profile section."
                        class="card_img img-fluid"
                        img={Book}
                      />
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        )}

        {Mobile && (
          <>
            <div className="cnt_4 mt-5">
              <div className="row">
                <div className="col-12 text-center mt-3">
                  <h1 className="cnt4_tit">
                    HOW <span className="en">EN</span>TURF WORKS
                  </h1>
                </div>
              </div>
            </div>
            <div className="row cards  justify-content-center  mt-5">
              <div className="col-sm-5  mt-5">
                <div className="reserve text-center">
                <img src={Book} className="book" alt="p"></img>
                  <h1 className="en_tit mt-4 ms-3">Reserve</h1>
                  <p className="reserve_des mt-3">
                    Download the Entruf App
                 Pick a timeslot and book it.
                  </p>
                  </div>
                </div>
                <div className="col-sm-5 mt-5">
                <div className="record text-center">
                <img src={Book} className="book" alt="p"></img>

                  <h1 className="en_tit mt-4 ms-3">Record</h1>
                  <p className="record_des mt-3">
                 Our AI enabled cameras record the match, no extra cost. 
                  </p>
                </div>
            </div>
            <div className="col-sm-5 mt-5">
                <div className="relive text-center">
                <img src={Book} className="book" alt="p"></img>

                  <h1 className="en_tit mt-4 ms-3">Relive</h1>
                  <p className="relive_des mt-3">
                  Recorded videos are available in profile section.
                  </p>
                </div>
                </div>
           </div>
          
          </>
        )}

      </div>
    </>
  );
}

export default Enturf_wrk;
